export default __webpack_public_path__ + "static/media/0x03678f2c2c762dc63c2bb738c3a837d366eda560.f817dee0.webp";